export const PERKS = "perks"
export const RECOGNITION = "recognition"
export const REWARD = "reward"
export const MEDICAL = "medical"
export const ONLINEGP = "onlinegp"
export const WALLET = "wallet"
export const PLATFORM = "platform"
export const ONBOARDING = "onboarding"
export const TOUR = "tour"
export const WELLNESS = "wellness"
export const HOMEPAGE = "homepage"
export const ADMIN = "admin"
